import { MaintenanceSettingPage } from "@/features/system-setting/pages/MaintenanceSetting";

const MaintenanceSetting = () => {
  return <MaintenanceSettingPage />;
};

export default MaintenanceSetting;
